import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const Moving = () => {
    const { t } = useTranslation('postmeeting')
    const navigate = useNavigate()

    // Redirect to meeting after 2 seconds
    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/meeting')
        }, 2000)
        return () => clearTimeout(timer)
    }, [navigate])

    return (
        <div className="row-2">
            <div className="icon rounded-icon">
                <FontAwesomeIcon icon={['far', 'arrow-right']} style={{ color: '#00A3FF' }} />
            </div>
            <h1>{t('moving.title')}</h1>
        </div>
    )
}
